import type { FC, ReactNode } from "react";

import { Flex } from "@/ui/components/layout";
import {
  OverlappingImageGroup,
  type TImageProps,
} from "@/ui/components/primitives";
import { TextBody } from "@/ui/components/typography/TextBody";

export type TSocialMediaCalloutFooterProps = {
  images: TImageProps[];
  label: ReactNode;
};

export const SocialMediaCalloutFooter: FC<TSocialMediaCalloutFooterProps> = ({
  images,
  label,
}) => {
  return (
    <Flex
      data-component="SocialMediaCalloutFooter"
      className="mt-8"
      align="center"
      justify="center"
      gap="2"
    >
      <OverlappingImageGroup images={images} size="sm" />
      <TextBody size={3} isResponsive={false} className="text-foreground-muted-strong">
        { label }
      </TextBody>
    </Flex>
  );
};

SocialMediaCalloutFooter.displayName = "SocialMediaCalloutFooter";
